'use strict';

( function ( $ ) {
	$( '.faq__item-question' ).on( 'click', function () {
		if ( ! $( this ).parents( '.faq__item' ).hasClass( 'open' ) ) {
			$( '.faq__item-question' )
				.parents( '.faq__item' )
				.removeClass( 'open' );
			$( '.faq__item-question' )
				.siblings( '.faq__item-answer' )
				.slideUp();
		}
		$( this ).parents( '.faq__item' ).toggleClass( 'open' );
		$( this ).siblings( '.faq__item-answer' ).slideToggle();
	} );
} )( jQuery );
